import { Base64Helper } from "@/utils/base64";
import { VueRouter } from "vue-router/types/router";

export const openFile = (fileUrl: string, router: VueRouter) => {
  const b64 = Base64Helper.toBase64(fileUrl);

  const url =
    window.location.origin +
    "/" +
    router.resolve({
      name: "file-viewer",
      params: {}
    }).href +
    `?id=${b64}`;
  window.open(url);
};
